import { useCallback, useEffect, useState } from 'react';

import ResizeObserver from 'lib/resize-observer';
import { calculateTableFixedValuesBasedOnContainer } from './table-view.utils';

export const ColGroups = ({ columnWidths }: { columnWidths: number[] }) => {
  return (
    <colgroup>
      {columnWidths.map((width, index) => (
        <col
          key={index}
          style={{
            width: `${width}px`,
          }}
        />
      ))}
    </colgroup>
  );
};

export const ColGroupsView = ({
  columnWidths,
  containerElement,
}: {
  columnWidths: number[];
  containerElement: HTMLElement | null;
}) => {
  const [widths, setWidths] = useState<number[]>(columnWidths);

  const computeColumnWidths = useCallback(() => {
    setWidths(
      calculateTableFixedValuesBasedOnContainer(
        containerElement?.offsetWidth || 1000,
        columnWidths
      )
    );
  }, [columnWidths, containerElement?.offsetWidth, setWidths]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(computeColumnWidths);

    if (containerElement) {
      resizeObserver.observe(containerElement);
    }

    return () => {
      if (containerElement) {
        resizeObserver.unobserve(containerElement);
      }
    };
  }, [containerElement, computeColumnWidths]);

  return (
    <colgroup>
      {widths.map((width, index) => (
        <col
          key={index}
          style={{
            width: `${width}px`,
          }}
        />
      ))}
    </colgroup>
  );
};
